import { useBuyerGlobalSocketHandler } from 'services/socket/handleBuyerEvents';
import { useMyBidsSocketEffect } from 'services/socket/handleMyBidsEvent';
import { useMySalesSocketEffect } from '../../services/socket/handleSaleEvents';
import { useSelector } from 'react-redux';

export default function GlobalSocketProvider() {
  const user = useSelector((state: any) => state.user.user);
  if (user?.role === 'buyer') {
    return <BuyerSocketProvider />;
  }

  if (user?.role === 'seller') {
    return <SellerSocketProvider />;
  }

  return null;
}

const BuyerSocketProvider = () => {
  useBuyerGlobalSocketHandler();
  useMyBidsSocketEffect();

  return null;
};

const SellerSocketProvider = () => {
  useMySalesSocketEffect();

  return null;
};
